<template>
  <div class="col-sm-6 col-lg-4" :class="id === 899 ? 'd-none' : ''">
    <router-link :to="`${slug}#PersonalInformation`" class="blog-entry">
      <div class="entry-photo">
        <!-- <img v-bind:src="'//api.diu.ac/' + image" :alt="name"> -->

        <v-lazy-image :src="'//api.diu.ac/' + image" :alt="name" />
      </div>
      <h3>{{ name }}</h3>
      <p class="designation">{{ designation }}, {{ department }}</p>
      <p>
        <em>{{ email }}</em>
      </p>
      <!-- <div class="d-flex justify-content-center align-items-center mt-2">
        <star-rating
          :rating="parseInt(averageRating)"
          :star-size="20"
          :read-only="true"
          :animate="true"
          :glow="5"
          :showRating="false"
          :increment="0.01"
          :fixed-points="2"
          :border-width="0.5"
          active-color="#FFA41C"
          glowColor="#FFA41C"
          border-color="#de7921"
        />
        <span class="ml-2"
          >{{ averageRating }}/5 ({{ totalRatingProvider }})</span
        >
      </div> -->
    </router-link>
  </div>
</template>

<script>
import VLazyImage from "v-lazy-image";
import StarRating from "vue-star-rating";

export default {
  name: "EmployeeCard",
  components: {
    "v-lazy-image": VLazyImage,
    "star-rating": StarRating
  },
  props: [
    "slug",
    "image",
    "name",
    "designation",
    "department",
    "email",
    "id",
    "averageRating",
    "totalRatingProvider"
  ],
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>

<style scoped>
.v-lazy-image {
  filter: blur(10px);
  transition: filter 0.7s;
}

.v-lazy-image-loaded {
  filter: blur(0);
}
</style>



// WEBPACK FOOTER //
// src/components/EmployeeCard.vue